var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link.href}},[_c('picture',[_c('source',{attrs:{"srcset":_vm.webpString,"type":"image/webp"}}),_c('img',{attrs:{"src":_vm.srcString,"srcset":_vm.pngString,"alt":_vm.link.title}})]),_c('p',[_vm._v(_vm._s(_vm.link.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }